export default "/assets/confetti-scoreboard.svg";